<template>
  <div class="subject">
    <div class="form">
      <el-form ref="formCustom" :model="formCustom" class="formCustom" label-width="150px" status-icon>
        <el-form-item label="姓名：" prop="adminNikeName">
          <el-input v-model="formCustom.adminNikeName" :disabled="true" autocomplete="off" class="input"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="adminTelephone">
          <el-input v-model="formCustom.adminTelephone" :disabled="true" autocomplete="off" class="input"></el-input>
        </el-form-item>
        <el-form-item label="申请时间：" prop="createTime">
          <el-input v-model="formCustom.createTime" :disabled="true" autocomplete="off" class="input"></el-input>
        </el-form-item>
        <el-form-item v-if="formCustom.approvalIdea" prop="approvalIdea">
          <template slot="label">
            <div style="color: red;">审批意见：</div>
          </template>
          <el-input v-model="formCustom.approvalIdea" :disabled="true" :rows="4" style="width: 400px;"
                    type="textarea"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :loading="submitLoading" class="next" type="primary" @click="submitForm('formCustom')">关闭
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {companyInvitationDetail} from '@/api/organization'

export default {
  name: "companyInvitationApprovalDetail",
  props: {
    row: {
      // 定义接收的类型 还可以定义多种类型 [String, Undefined, Number]
      // 如果required为true,尽量type允许undefined类型，因为传递过来的参数是异步的。或者设置默认值。
      type: Object,
      // 定义是否必须传
      required: true,
      // 定义默认值
      default: {}
    }
  },
  data() {
    return {
      formCustom: {
        adminNikeName: "",
        adminTelephone: "",
        createTime: ""
      },
      submitLoading: false
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      companyInvitationDetail(this.row.companyInvitationId).then((res) => {
        this.formCustom = res.data.data
      })
    },
    submitForm(formName) {
      this.$emit('detailSuccess')
    }
  }
}
</script>

<style lang="less" scoped>
.subject {
  .select {
    display: flex;
    flex-direction: column;
    align-items: center;

    .box-card {
      margin-top: 80px;
      text-align: left;
      width: 700px;

      .h {
        font-size: 24px;
        margin-bottom: 10px;
      }

      .item {
        font-size: 16px;
      }
    }
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .next {
      border-radius: 4px;
      background-color: rgba(0, 123, 211, 1);
      color: rgba(255, 255, 255, 1);
      font-size: 18px;
      height: 50px;
      border-color: #3a62d7;
      width: 300px;
    }

    .formCustom {
      margin-left: 30px;

      .input {
        width: 400px;
      }
    }

    .back {
      cursor: pointer;
      width: 376px;
      color: rgba(16, 16, 16, 1);
      font-size: 16px;
      text-align: left;

      i {
        border: 3px solid black;
        border-width: 0px 1px 1px 0px;
        display: inline-block;
        padding: 5px;
      }

      .left {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
      }
    }
  }
}
</style>
